/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BodyUploadLogoApplicationUploadLogoPost,
  BodyUploadProfilePictureApplicationUploadProfilePicturePost,
  BodyUploadResumeApplicationUploadResumePost,
  CohortResponse,
  F5ApplicationParameters,
  HTTPValidationError,
  IndividualApplicationParameters,
  LumenApplicationParameters,
  LumenSubmissionResponse,
  OrganizationApplicationParameters,
  OrganizationApplicationStatusResponse,
  OrganizationExistsParams,
  OrganizationExistsResponse,
  OrganizationSubmissionResponse,
  ProfessionalApplicationParameters,
  ProfessionalApplicationStatusResponse,
  ProfessionalSubmissionResponse,
  ReckittApplicationParameters,
  SAPApplicationParameters,
  SAPSubmissionResponse,
  UploadLogo200,
  UploadProfilePicture200,
  UploadResume200,
} from './platformapi.schemas';

import getAvailableCohortsSapMutator from '../custom-axios-instance';
import getOrganizationApplicationStatusMutator from '../custom-axios-instance';
import organizationExistsMutator from '../custom-axios-instance';
import countOrganizationApplicationsAdminMutator from '../custom-axios-instance';
import getProfessionalApplicationStatusMutator from '../custom-axios-instance';
import countProfessionalApplicationsAdminMutator from '../custom-axios-instance';
import submitEyApplicationMutator from '../custom-axios-instance';
import submitF5ApplicationMutator from '../custom-axios-instance';
import submitIndividualApplicationMutator from '../custom-axios-instance';
import submitLumenApplicationMutator from '../custom-axios-instance';
import submitOrganizationApplicationMutator from '../custom-axios-instance';
import submitReckittApplicationMutator from '../custom-axios-instance';
import submitSapApplicationMutator from '../custom-axios-instance';
import uploadLogoMutator from '../custom-axios-instance';
import uploadProfilePictureMutator from '../custom-axios-instance';
import uploadResumeMutator from '../custom-axios-instance';

/**
 * Get cohorts with current application periods, or those whose ended within the past ten days
 * @summary Get Available Cohorts Sap
 */
export const getAvailableCohortsSap = (signal?: AbortSignal) => {
  return getAvailableCohortsSapMutator<CohortResponse[]>({
    url: `${import.meta.env['VITE_API_HOST']}/application/available-cohorts-sap`,
    method: 'GET',
    signal,
  });
};

export const getGetAvailableCohortsSapQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/application/available-cohorts-sap`] as const;
};

export const getGetAvailableCohortsSapQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableCohortsSap>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAvailableCohortsSap>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableCohortsSapQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableCohortsSap>>> = ({ signal }) =>
    getAvailableCohortsSap(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableCohortsSap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailableCohortsSapQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableCohortsSap>>
>;
export type GetAvailableCohortsSapQueryError = void;

export function useGetAvailableCohortsSap<
  TData = Awaited<ReturnType<typeof getAvailableCohortsSap>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableCohortsSap>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableCohortsSap>>,
          TError,
          Awaited<ReturnType<typeof getAvailableCohortsSap>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableCohortsSap<
  TData = Awaited<ReturnType<typeof getAvailableCohortsSap>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableCohortsSap>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableCohortsSap>>,
          TError,
          Awaited<ReturnType<typeof getAvailableCohortsSap>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableCohortsSap<
  TData = Awaited<ReturnType<typeof getAvailableCohortsSap>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableCohortsSap>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Available Cohorts Sap
 */

export function useGetAvailableCohortsSap<
  TData = Awaited<ReturnType<typeof getAvailableCohortsSap>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableCohortsSap>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAvailableCohortsSapQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the application status for an organization
 * @summary Get Organization Application Status
 */
export const getOrganizationApplicationStatus = (signal?: AbortSignal) => {
  return getOrganizationApplicationStatusMutator<OrganizationApplicationStatusResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/organization-application-status`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationApplicationStatusQueryKey = () => {
  return [
    `${import.meta.env['VITE_API_HOST']}/application/organization-application-status`,
  ] as const;
};

export const getGetOrganizationApplicationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOrganizationApplicationStatus>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationApplicationStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationApplicationStatus>>> = ({
    signal,
  }) => getOrganizationApplicationStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationApplicationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationApplicationStatus>>
>;
export type GetOrganizationApplicationStatusQueryError = void | HTTPValidationError;

export function useGetOrganizationApplicationStatus<
  TData = Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationApplicationStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationApplicationStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationApplicationStatus<
  TData = Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationApplicationStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationApplicationStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationApplicationStatus<
  TData = Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationApplicationStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Application Status
 */

export function useGetOrganizationApplicationStatus<
  TData = Awaited<ReturnType<typeof getOrganizationApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationApplicationStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationApplicationStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Check if an organization with the given name already exists and is not already affiliated to user
 * @summary Organization Exists
 */
export const organizationExists = (params: OrganizationExistsParams, signal?: AbortSignal) => {
  return organizationExistsMutator<OrganizationExistsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/organization-exists`,
    method: 'GET',
    params,
    signal,
  });
};

export const getOrganizationExistsQueryKey = (params: OrganizationExistsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/application/organization-exists`,
    ...(params ? [params] : []),
  ] as const;
};

export const getOrganizationExistsQueryOptions = <
  TData = Awaited<ReturnType<typeof organizationExists>>,
  TError = void | HTTPValidationError,
>(
  params: OrganizationExistsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationExists>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrganizationExistsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationExists>>> = ({ signal }) =>
    organizationExists(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organizationExists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OrganizationExistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationExists>>
>;
export type OrganizationExistsQueryError = void | HTTPValidationError;

export function useOrganizationExists<
  TData = Awaited<ReturnType<typeof organizationExists>>,
  TError = void | HTTPValidationError,
>(
  params: OrganizationExistsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationExists>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationExists>>,
          TError,
          Awaited<ReturnType<typeof organizationExists>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationExists<
  TData = Awaited<ReturnType<typeof organizationExists>>,
  TError = void | HTTPValidationError,
>(
  params: OrganizationExistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof organizationExists>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationExists>>,
          TError,
          Awaited<ReturnType<typeof organizationExists>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationExists<
  TData = Awaited<ReturnType<typeof organizationExists>>,
  TError = void | HTTPValidationError,
>(
  params: OrganizationExistsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationExists>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Organization Exists
 */

export function useOrganizationExists<
  TData = Awaited<ReturnType<typeof organizationExists>>,
  TError = void | HTTPValidationError,
>(
  params: OrganizationExistsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationExists>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOrganizationExistsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves the count of organization applications
 * @summary Count Organization Applications Admin
 */
export const countOrganizationApplicationsAdmin = (signal?: AbortSignal) => {
  return countOrganizationApplicationsAdminMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/application/organization/count`,
    method: 'GET',
    signal,
  });
};

export const getCountOrganizationApplicationsAdminQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/application/organization/count`] as const;
};

export const getCountOrganizationApplicationsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountOrganizationApplicationsAdminQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>> = ({
    signal,
  }) => countOrganizationApplicationsAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountOrganizationApplicationsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>
>;
export type CountOrganizationApplicationsAdminQueryError = void | HTTPValidationError;

export function useCountOrganizationApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountOrganizationApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountOrganizationApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Organization Applications Admin
 */

export function useCountOrganizationApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countOrganizationApplicationsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountOrganizationApplicationsAdminQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the application status for SAP
 * @summary Get Professional Application Status
 */
export const getProfessionalApplicationStatus = (signal?: AbortSignal) => {
  return getProfessionalApplicationStatusMutator<ProfessionalApplicationStatusResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/professional-application-status`,
    method: 'GET',
    signal,
  });
};

export const getGetProfessionalApplicationStatusQueryKey = () => {
  return [
    `${import.meta.env['VITE_API_HOST']}/application/professional-application-status`,
  ] as const;
};

export const getGetProfessionalApplicationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getProfessionalApplicationStatus>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfessionalApplicationStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfessionalApplicationStatus>>> = ({
    signal,
  }) => getProfessionalApplicationStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProfessionalApplicationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfessionalApplicationStatus>>
>;
export type GetProfessionalApplicationStatusQueryError = void | HTTPValidationError;

export function useGetProfessionalApplicationStatus<
  TData = Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalApplicationStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalApplicationStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalApplicationStatus<
  TData = Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalApplicationStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalApplicationStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalApplicationStatus<
  TData = Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalApplicationStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Professional Application Status
 */

export function useGetProfessionalApplicationStatus<
  TData = Awaited<ReturnType<typeof getProfessionalApplicationStatus>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalApplicationStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProfessionalApplicationStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves the count of professional user applications
 * @summary Count Professional Applications Admin
 */
export const countProfessionalApplicationsAdmin = (signal?: AbortSignal) => {
  return countProfessionalApplicationsAdminMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/application/professional/count`,
    method: 'GET',
    signal,
  });
};

export const getCountProfessionalApplicationsAdminQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/application/professional/count`] as const;
};

export const getCountProfessionalApplicationsAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountProfessionalApplicationsAdminQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>> = ({
    signal,
  }) => countProfessionalApplicationsAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountProfessionalApplicationsAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>
>;
export type CountProfessionalApplicationsAdminQueryError = void | HTTPValidationError;

export function useCountProfessionalApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountProfessionalApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
          TError,
          Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountProfessionalApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Professional Applications Admin
 */

export function useCountProfessionalApplicationsAdmin<
  TData = Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countProfessionalApplicationsAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountProfessionalApplicationsAdminQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Submit an EY application
 * @summary Submit Ey Application
 */
export const submitEyApplication = (
  professionalApplicationParameters: ProfessionalApplicationParameters,
  signal?: AbortSignal,
) => {
  return submitEyApplicationMutator<ProfessionalSubmissionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/submit-ey`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: professionalApplicationParameters,
    signal,
  });
};

export const getSubmitEyApplicationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitEyApplication>>,
    TError,
    { data: ProfessionalApplicationParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitEyApplication>>,
  TError,
  { data: ProfessionalApplicationParameters },
  TContext
> => {
  const mutationKey = ['submitEyApplication'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitEyApplication>>,
    { data: ProfessionalApplicationParameters }
  > = (props) => {
    const { data } = props ?? {};

    return submitEyApplication(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitEyApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitEyApplication>>
>;
export type SubmitEyApplicationMutationBody = ProfessionalApplicationParameters;
export type SubmitEyApplicationMutationError = void | HTTPValidationError;

/**
 * @summary Submit Ey Application
 */
export const useSubmitEyApplication = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitEyApplication>>,
      TError,
      { data: ProfessionalApplicationParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitEyApplication>>,
  TError,
  { data: ProfessionalApplicationParameters },
  TContext
> => {
  const mutationOptions = getSubmitEyApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit an F5 application
 * @summary Submit F5 Application
 */
export const submitF5Application = (
  f5ApplicationParameters: F5ApplicationParameters,
  signal?: AbortSignal,
) => {
  return submitF5ApplicationMutator<ProfessionalSubmissionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/submit-f5`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: f5ApplicationParameters,
    signal,
  });
};

export const getSubmitF5ApplicationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitF5Application>>,
    TError,
    { data: F5ApplicationParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitF5Application>>,
  TError,
  { data: F5ApplicationParameters },
  TContext
> => {
  const mutationKey = ['submitF5Application'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitF5Application>>,
    { data: F5ApplicationParameters }
  > = (props) => {
    const { data } = props ?? {};

    return submitF5Application(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitF5ApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitF5Application>>
>;
export type SubmitF5ApplicationMutationBody = F5ApplicationParameters;
export type SubmitF5ApplicationMutationError = void | HTTPValidationError;

/**
 * @summary Submit F5 Application
 */
export const useSubmitF5Application = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitF5Application>>,
      TError,
      { data: F5ApplicationParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitF5Application>>,
  TError,
  { data: F5ApplicationParameters },
  TContext
> => {
  const mutationOptions = getSubmitF5ApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit an individual application
 * @summary Submit Individual Application
 */
export const submitIndividualApplication = (
  individualApplicationParameters: IndividualApplicationParameters,
  signal?: AbortSignal,
) => {
  return submitIndividualApplicationMutator<ProfessionalSubmissionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/submit-individual`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: individualApplicationParameters,
    signal,
  });
};

export const getSubmitIndividualApplicationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitIndividualApplication>>,
    TError,
    { data: IndividualApplicationParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitIndividualApplication>>,
  TError,
  { data: IndividualApplicationParameters },
  TContext
> => {
  const mutationKey = ['submitIndividualApplication'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitIndividualApplication>>,
    { data: IndividualApplicationParameters }
  > = (props) => {
    const { data } = props ?? {};

    return submitIndividualApplication(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitIndividualApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitIndividualApplication>>
>;
export type SubmitIndividualApplicationMutationBody = IndividualApplicationParameters;
export type SubmitIndividualApplicationMutationError = void | HTTPValidationError;

/**
 * @summary Submit Individual Application
 */
export const useSubmitIndividualApplication = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitIndividualApplication>>,
      TError,
      { data: IndividualApplicationParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitIndividualApplication>>,
  TError,
  { data: IndividualApplicationParameters },
  TContext
> => {
  const mutationOptions = getSubmitIndividualApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit a Lumen application
 * @summary Submit Lumen Application
 */
export const submitLumenApplication = (
  lumenApplicationParameters: LumenApplicationParameters,
  signal?: AbortSignal,
) => {
  return submitLumenApplicationMutator<LumenSubmissionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/submit-lumen`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: lumenApplicationParameters,
    signal,
  });
};

export const getSubmitLumenApplicationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitLumenApplication>>,
    TError,
    { data: LumenApplicationParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitLumenApplication>>,
  TError,
  { data: LumenApplicationParameters },
  TContext
> => {
  const mutationKey = ['submitLumenApplication'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitLumenApplication>>,
    { data: LumenApplicationParameters }
  > = (props) => {
    const { data } = props ?? {};

    return submitLumenApplication(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitLumenApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitLumenApplication>>
>;
export type SubmitLumenApplicationMutationBody = LumenApplicationParameters;
export type SubmitLumenApplicationMutationError = void | HTTPValidationError;

/**
 * @summary Submit Lumen Application
 */
export const useSubmitLumenApplication = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitLumenApplication>>,
      TError,
      { data: LumenApplicationParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitLumenApplication>>,
  TError,
  { data: LumenApplicationParameters },
  TContext
> => {
  const mutationOptions = getSubmitLumenApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit an organization application
 * @summary Submit Organization Application
 */
export const submitOrganizationApplication = (
  organizationApplicationParameters: OrganizationApplicationParameters,
  signal?: AbortSignal,
) => {
  return submitOrganizationApplicationMutator<OrganizationSubmissionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/submit-organization`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: organizationApplicationParameters,
    signal,
  });
};

export const getSubmitOrganizationApplicationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitOrganizationApplication>>,
    TError,
    { data: OrganizationApplicationParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitOrganizationApplication>>,
  TError,
  { data: OrganizationApplicationParameters },
  TContext
> => {
  const mutationKey = ['submitOrganizationApplication'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitOrganizationApplication>>,
    { data: OrganizationApplicationParameters }
  > = (props) => {
    const { data } = props ?? {};

    return submitOrganizationApplication(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitOrganizationApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitOrganizationApplication>>
>;
export type SubmitOrganizationApplicationMutationBody = OrganizationApplicationParameters;
export type SubmitOrganizationApplicationMutationError = void | HTTPValidationError;

/**
 * @summary Submit Organization Application
 */
export const useSubmitOrganizationApplication = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitOrganizationApplication>>,
      TError,
      { data: OrganizationApplicationParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitOrganizationApplication>>,
  TError,
  { data: OrganizationApplicationParameters },
  TContext
> => {
  const mutationOptions = getSubmitOrganizationApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit a Reckitt application
 * @summary Submit Reckitt Application
 */
export const submitReckittApplication = (
  reckittApplicationParameters: ReckittApplicationParameters,
  signal?: AbortSignal,
) => {
  return submitReckittApplicationMutator<ProfessionalSubmissionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/submit-reckitt`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reckittApplicationParameters,
    signal,
  });
};

export const getSubmitReckittApplicationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitReckittApplication>>,
    TError,
    { data: ReckittApplicationParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitReckittApplication>>,
  TError,
  { data: ReckittApplicationParameters },
  TContext
> => {
  const mutationKey = ['submitReckittApplication'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitReckittApplication>>,
    { data: ReckittApplicationParameters }
  > = (props) => {
    const { data } = props ?? {};

    return submitReckittApplication(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitReckittApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitReckittApplication>>
>;
export type SubmitReckittApplicationMutationBody = ReckittApplicationParameters;
export type SubmitReckittApplicationMutationError = void | HTTPValidationError;

/**
 * @summary Submit Reckitt Application
 */
export const useSubmitReckittApplication = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitReckittApplication>>,
      TError,
      { data: ReckittApplicationParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitReckittApplication>>,
  TError,
  { data: ReckittApplicationParameters },
  TContext
> => {
  const mutationOptions = getSubmitReckittApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit an SAP application
 * @summary Submit Sap Application
 */
export const submitSapApplication = (
  sAPApplicationParameters: SAPApplicationParameters,
  signal?: AbortSignal,
) => {
  return submitSapApplicationMutator<SAPSubmissionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/application/submit-sap`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sAPApplicationParameters,
    signal,
  });
};

export const getSubmitSapApplicationMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitSapApplication>>,
    TError,
    { data: SAPApplicationParameters },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitSapApplication>>,
  TError,
  { data: SAPApplicationParameters },
  TContext
> => {
  const mutationKey = ['submitSapApplication'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitSapApplication>>,
    { data: SAPApplicationParameters }
  > = (props) => {
    const { data } = props ?? {};

    return submitSapApplication(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitSapApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitSapApplication>>
>;
export type SubmitSapApplicationMutationBody = SAPApplicationParameters;
export type SubmitSapApplicationMutationError = void | HTTPValidationError;

/**
 * @summary Submit Sap Application
 */
export const useSubmitSapApplication = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitSapApplication>>,
      TError,
      { data: SAPApplicationParameters },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitSapApplication>>,
  TError,
  { data: SAPApplicationParameters },
  TContext
> => {
  const mutationOptions = getSubmitSapApplicationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Upload a logo for an organization application
 * @summary Upload Logo
 */
export const uploadLogo = (
  bodyUploadLogoApplicationUploadLogoPost: BodyUploadLogoApplicationUploadLogoPost,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadLogoApplicationUploadLogoPost.file);

  return uploadLogoMutator<UploadLogo200>({
    url: `${import.meta.env['VITE_API_HOST']}/application/upload-logo`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getUploadLogoMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadLogo>>,
    TError,
    { data: BodyUploadLogoApplicationUploadLogoPost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadLogo>>,
  TError,
  { data: BodyUploadLogoApplicationUploadLogoPost },
  TContext
> => {
  const mutationKey = ['uploadLogo'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadLogo>>,
    { data: BodyUploadLogoApplicationUploadLogoPost }
  > = (props) => {
    const { data } = props ?? {};

    return uploadLogo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadLogoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadLogo>>>;
export type UploadLogoMutationBody = BodyUploadLogoApplicationUploadLogoPost;
export type UploadLogoMutationError = void | HTTPValidationError;

/**
 * @summary Upload Logo
 */
export const useUploadLogo = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadLogo>>,
      TError,
      { data: BodyUploadLogoApplicationUploadLogoPost },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadLogo>>,
  TError,
  { data: BodyUploadLogoApplicationUploadLogoPost },
  TContext
> => {
  const mutationOptions = getUploadLogoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Upload a profile picture
 * @summary Upload Profile Picture
 */
export const uploadProfilePicture = (
  bodyUploadProfilePictureApplicationUploadProfilePicturePost: BodyUploadProfilePictureApplicationUploadProfilePicturePost,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadProfilePictureApplicationUploadProfilePicturePost.file);

  return uploadProfilePictureMutator<UploadProfilePicture200>({
    url: `${import.meta.env['VITE_API_HOST']}/application/upload-profile-picture`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getUploadProfilePictureMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadProfilePicture>>,
    TError,
    { data: BodyUploadProfilePictureApplicationUploadProfilePicturePost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadProfilePicture>>,
  TError,
  { data: BodyUploadProfilePictureApplicationUploadProfilePicturePost },
  TContext
> => {
  const mutationKey = ['uploadProfilePicture'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadProfilePicture>>,
    { data: BodyUploadProfilePictureApplicationUploadProfilePicturePost }
  > = (props) => {
    const { data } = props ?? {};

    return uploadProfilePicture(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadProfilePictureMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadProfilePicture>>
>;
export type UploadProfilePictureMutationBody =
  BodyUploadProfilePictureApplicationUploadProfilePicturePost;
export type UploadProfilePictureMutationError = void | HTTPValidationError;

/**
 * @summary Upload Profile Picture
 */
export const useUploadProfilePicture = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadProfilePicture>>,
      TError,
      { data: BodyUploadProfilePictureApplicationUploadProfilePicturePost },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadProfilePicture>>,
  TError,
  { data: BodyUploadProfilePictureApplicationUploadProfilePicturePost },
  TContext
> => {
  const mutationOptions = getUploadProfilePictureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Upload a resume file
 * @summary Upload Resume
 */
export const uploadResume = (
  bodyUploadResumeApplicationUploadResumePost: BodyUploadResumeApplicationUploadResumePost,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadResumeApplicationUploadResumePost.file);

  return uploadResumeMutator<UploadResume200>({
    url: `${import.meta.env['VITE_API_HOST']}/application/upload-resume`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getUploadResumeMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadResume>>,
    TError,
    { data: BodyUploadResumeApplicationUploadResumePost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadResume>>,
  TError,
  { data: BodyUploadResumeApplicationUploadResumePost },
  TContext
> => {
  const mutationKey = ['uploadResume'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadResume>>,
    { data: BodyUploadResumeApplicationUploadResumePost }
  > = (props) => {
    const { data } = props ?? {};

    return uploadResume(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadResumeMutationResult = NonNullable<Awaited<ReturnType<typeof uploadResume>>>;
export type UploadResumeMutationBody = BodyUploadResumeApplicationUploadResumePost;
export type UploadResumeMutationError = void | HTTPValidationError;

/**
 * @summary Upload Resume
 */
export const useUploadResume = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadResume>>,
      TError,
      { data: BodyUploadResumeApplicationUploadResumePost },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadResume>>,
  TError,
  { data: BodyUploadResumeApplicationUploadResumePost },
  TContext
> => {
  const mutationOptions = getUploadResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
